module.exports = __webpack_public_path__ + "img/icon_manejo_requisicion_materiales_y_equipos.6fe164c0.svg";